import { ApiClient } from '~/apiclient/apiclient'
import { FeedLinkApi, SeriesApi } from '~/apiclient/apiseries'

export type SeriesDefaultSortOptions =
  | 'newest'
  | 'oldest'
  | 'updated'
  | 'downloads'
  | 'lastplayed'
  | 'title'

export interface SeriesPatchParams {
  title?: string
  description?: string
  defaultSortBy?: SeriesDefaultSortOptions
  feedLinks?: FeedLinkApi[]
  podcastEnabled?: boolean
  podcastEmail?: string | null
  podcastSpeaker?: string | null
}

export async function createSeries(
  this: ApiClient,
  seriesParams: SeriesPatchParams,
  broadcasterID: string
): Promise<SeriesApi> {
  const { data } = await this.$axios.post(`node/series`, {
    ...seriesParams,
    broadcasterID,
  })
  return data
}

export async function getSeriesImageUploadUrl(
  this: ApiClient,
  seriesID: number
): Promise<string> {
  const { data } = await this.$axios.post(`/media/images/series/${seriesID}`)
  return data.uploadURL
}

export async function deleteSeriesImage(
  this: ApiClient,
  seriesID: number
): Promise<void> {
  return await this.$axios.delete(`/media/images/series/${seriesID}`)
}

export async function deleteSeries(
  this: ApiClient,
  seriesID: number | string
): Promise<string> {
  return await this.$axios.delete(`node/series/${seriesID}`)
}

export async function patchSeries(
  this: ApiClient,
  seriesID: number | string,
  params: SeriesPatchParams
): Promise<string> {
  return await this.$axios.patch(`node/series/${seriesID}`, params)
}
